module.exports = __webpack_public_path__ + "img/tarifspetitgite.31f66a18.jpg";